import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';
import { IDashboardCustomer } from '../../interfaces/dashboard';
import { ITaskFilter } from '../../interfaces/task-filter';
import { ITaskInfo } from '../../interfaces/task-info';
import { CustomerService } from '../../services';
import { DashboardService } from '../../services';
import { FileStorageService } from '../../services';
import { TaskService } from '../../services';
import { UserService } from '../../services';
import { flatten } from '../../utils/flatten';

@Component({
  selector: 'dashboard-customer',
  styleUrls: ['./dashboard-customer.component.css'],
  templateUrl: './dashboard-customer.component.html',
})
export class DashboardCustomerComponent implements OnInit {
  inboxType_VmeInbox = 1;
  inboxType_SupplierExistingJobs = 2;
  inboxType_CustomerInbox = 3;

  customerInboxType_Waiting = 2;
  customerInboxType_Unallocated = 1;
  customerInboxType_Completed = 3;
  customerInboxType_Live = 4;

  private subscription: Subscription;
  public taskList: any[];
  public from: string;
  public to: string;
  public filterVal: ITaskFilter;

  public data: IDashboardCustomer = {};
  public ordersByDay: any = {};
  public ordersByDayOptions: any = {};
  public ordersByHour: any = {};
  public ordersByHourOptions: any = {};

  public _selectedTask: ITaskInfo;
  public logo: string = '';
  public orgName: string = '';

  constructor(
    private taskService: TaskService,
    private dashboardService: DashboardService,
    private router: Router,
    private userService: UserService,
    private customerService: CustomerService,
    private fileStorageService: FileStorageService,
  ) {}

  ngOnInit() {
    this.customerService.getOrganisationNameAndLogo().then((org) => {
      this.orgName = org.name;
      this.logo = org.logo;
    });

    this.initDefaultFilter();
    this.refreshTasks();
    // let timer = TimerObservable.create(0, 30000);
    // this.subscription = timer.subscribe(t => {
    //     this.refreshTasks();
    // });

    this.ordersByDayOptions = {
      scaleShowValues: true,
      legend: {
        display: false,
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              //stepSize: 1,
              autoSkip: true,
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };

    this.ordersByHourOptions = {
      scaleShowValues: true,
      legend: {
        display: false,
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              stepSize: 1,
              autoSkip: true,
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };

    this.dashboardService.getCustomer().then((result) => {
      this.data = result;

      this.ordersByDay = {
        labels: this.data.ordersByDayLabels,
        datasets: [
          {
            label: 'Orders',
            backgroundColor: '#42A5F5',
            borderColor: '#1E88E5',
            data: this.data.ordersByDayValues,
          },
        ],
      };

      this.ordersByHour = {
        labels: this.data.ordersByHourLabels,
        datasets: [
          {
            label: 'Orders',
            borderColor: '#1E88E5',
            data: this.data.ordersByHourValues,
          },
        ],
      };
    });
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: Number.MAX_SAFE_INTEGER / 2,
      sortField: '', // ASC
      sortOrder: 1,
      filters: {
        inboxType: { value: this.inboxType_CustomerInbox },
        from: {},
        to: {},
        taskType: { value: 0 },
        eregionId: { value: 0 },
        taskStep: { value: null },
        isTrackingData: { value: true },
        isDirectionsData: { value: true },
      },
    };
  }

  refreshTasks() {
    this.taskService.GetLiveTasks(flatten(this.filterVal)).then((data) => {
      console.log(data);
      this.taskList = data.items;
    });
  }

  goToInbox(event: Event, selectedInboxTab) {
    event.preventDefault();
    return this.router.navigate(['/app/customerinbox'], {
      queryParams: { selectedTab: selectedInboxTab },
    });
  }

  selectData(item) {
    return this.router.navigate(['/app/customerinbox'], {
      queryParams: { selectedTab: this.customerInboxType_Live },
    });
  }

  taskClick(item) {
    this.router.navigate([`app/jobscreen/${item.jobId}/${item.orderId}`]);
  }
}
